import DRAW_CREDIT from './draw-credit'
import SINGLE_PAYMENT_SCHEDULE_ACTION from './single-payment-schedule-action'
import { MULTI_PAYMENT_SCHEDULE_ACTION, EDIT_PROFILE, PPS_TO_LCS_COLLECTION } from './multi-payment-schedule-action'
export const PPS_DIALOG_LAYOUT_SETTING = {
  DRAW_CREDIT,
  SINGLE_PAYMENT_SCHEDULE_ACTION,
  MULTI_PAYMENT_SCHEDULE_ACTION,
  EDIT_PROFILE,
  PPS_TO_LCS_COLLECTION
}
